import React, { useState } from "react";

import { DateBox } from "devextreme-react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { WebRoutes } from "@constants/WebRoutes";

import "./SchoolManageDeadlines.scss";
import { SchoolManageDeadlinesModal } from "./SchoolManageDeadlinesModal/SchoolManageDeadlinesModal";

import BasicTable from "../../../../Components/BasicTable/BasicTable";

/**
 * SchoolManageDeadlinesView component renders a table displaying school deadlines data.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.dataSource - The transformed data to display in the table.
 * @param {Object} props.deadlineModal
 * @param {any} props.deadlineModal.deadline
 * @param {boolean} props.deadlineModal.showDeadlinesModal
 * @param {Function} props.deadlineModal.onDeadlinesModalInputChange
 * @param {Function} props.deadlineModal.onDeadlinesModalHide
 * @param {Function} props.deadlineModal.onDeadlinesModalSave
 * @param {(event: any) => void} props.onEditButtonClick - Callback function triggered when the edit button is clicked.
 */
export function SchoolManageDeadlinesView(props) {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const columns = [
        {
            name: "process",
            headerCaption: t("Process"),
            size: "large",
            caption: (row) => {
                switch (row.process) {
                    case "preRegSchoolEndDate":
                        return t("SchoolPreRegistration");
                    case "preRegSchoolAdminEndDate":
                        return t("IddinkPreRegistration");
                    case "preRegStudentEndDate":
                        return t("StudentReturn");
                    case "returningBooksEndDate":
                        return t("Handover");
                    default:
                        return "";
                }
            },
        },
        {
            name: "deadline",
            headerCaption: t("Deadline"),
            size: "large",
            caption: (row) => (row.deadline ? new Date(row.deadline).toLocaleDateString() : t("-")),
        },
        {
            name: "actions",
            headerCaption: t("Actions"),
            size: "normal",
            caption: (event) => (
                <Button
                    disabled={event.process === "returningBooksEndDate" || event.process === "preRegSchoolAdminEndDate"}
                    className="button"
                    onClick={() => props.onEditButtonClick(event)}
                >
                    {t("Edit")}
                </Button>
            ),
        },
    ];

    return (
        <div className="school-management-page">
            <BasicTable
                // @ts-ignore
                title={t("SchoolManageDeadlines")}
                columns={columns}
                datasource={props.dataSource}
            />
            {props.deadlineModal.showDeadlinesModal && (
                <SchoolManageDeadlinesModal
                    show={props.deadlineModal.showDeadlinesModal}
                    deadline={props.deadlineModal.deadline}
                    onInputChange={props.deadlineModal.onDeadlinesModalInputChange}
                    onHide={props.deadlineModal.onDeadlinesModalHide}
                    onSave={props.deadlineModal.onDeadlinesModalSave}
                />
            )}
        </div>
    );
}

export default SchoolManageDeadlinesView;
